module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader' || _vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("审批订单详情")])]), _vm._v(" "), (_vm.hasDisplayData) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "mouthNumber"
  }, [_vm._v("月度累积已消费金额：¥" + _vm._s(_vm.splitMoney(_vm.orderDetail.monthlyTotalApprovedAmount)))]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('span', {
    staticClass: "orderNumber",
    staticStyle: {
      "margin-top": "0",
      "color": "#424242"
    }
  }, [_vm._v("订单信息")]), _vm._v(" "), _c('span', {
    staticClass: "orderNumber"
  }, [_vm._v("下单成员：" + _vm._s(_vm.orderDetail.orderPerson))]), _vm._v(" "), _c('span', {
    staticClass: "orderNumber"
  }, [_vm._v("下单时间：" + _vm._s(_vm.orderDetail.orderTime))]), _vm._v(" "), _c('span', {
    staticClass: "orderNumber"
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderDetail.orderNo))]), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v("订单总金额：¥" + _vm._s(_vm.splitMoney(_vm.orderDetail.price)))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('span', {
    staticClass: "orderNumber",
    staticStyle: {
      "margin-top": "0",
      "color": "#424242"
    }
  }, [_vm._v("产品列表")]), _vm._v(" "), _vm._l((_vm.orderDetail.itemList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_3"
    }, [_c('div', {
      staticClass: "moneyWrap"
    }, [(item.TLNo) ? _c('span', {
      staticClass: "info_3"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.promoter3ID) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]) : _c('span', {
      staticClass: "info_3"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.tax) ? _c('div', {
      staticClass: "outer"
    }, [_c('span', {
      staticClass: "color_4"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v(_vm._s(item.tax))])]), _vm._v(" "), _c('span', {
      staticClass: "color_4"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v(_vm._s(item.symbol || item.microName))])]), _vm._v(" "), _c('span', {
      staticClass: "color_4"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v(_vm._s(item.nm_ID || item.microNo))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "periodWrap"
    }, [_c('div', {
      staticClass: "sectionWrap research-background-color"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v("周期：" + _vm._s(item.workdays) + "个工作日")])]), _vm._v(" "), _c('span', {
      staticClass: "money research-font-color"
    }, [_vm._v("¥" + _vm._s(_vm.splitMoney(item.price)))])])]), _vm._v(" "), _vm._m(0, true)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [(_vm.orderDetail.fromEmkt) ? _c('div', {
    staticClass: "col1",
    on: {
      "click": function($event) {
        return _vm.toggleResearchGroupDisagreeBox()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("不同意")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.fromEmkt) ? _c('div', {
    staticClass: "col2 research-background-color",
    on: {
      "click": function($event) {
        return _vm.agree()
      }
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("同意")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw",
      "visibility": "hidden"
    }
  }, [_vm._v("hidden")])]) : _vm._e(), _vm._v(" "), (_vm.showResearchGroupDisagreeBox) ? _c('ResearchGroupDisagreeBox', {
    on: {
      "toggleShow": _vm.toggleResearchGroupDisagreeBox,
      "confirm": _vm.disagree
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-952cb7e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupManagement/ApproveOrderDetail.vue
// module id = 1695
// module chunks = 8